export default {
  fromValue (val) {
    switch (val) {
      case 'requested':
        return 'Solicitada'
      case 'scheduled':
        return 'Agendada'
      case 'pending':
        return 'Pendente'
      case 'started':
        return 'Iniciada'
      case 'finished':
        return 'Finalizada'
      case 'canceled':
        return 'Cancelada'
      default:
        return val
    }
  }
}
